/**
 * Constants for the apiDataReducers
 */

/**
 * @type {{ITEM: string, COLLECTION: string}}
 */
const API_DATA_REDUCERS_TYPES = {
  ITEM:       'item',
  COLLECTION: 'collection',
};

export default API_DATA_REDUCERS_TYPES;


// WEBPACK FOOTER //
// ./src/reducers/apiDataReducers.types.js